export const tokens = {
    color: {
        brand: {
            50: "#eef5ff",
            100: "#d9e9ff",
            500: "#1769aa",
            600: "#0f568f",
            700: "#0b4776"
        },
        neutral: {
            0: "#ffffff",
            50: "#f7f9fc",
            100: "#edf1f7",
            600: "#52606d",
            900: "#152536"
        },
        semantic: {
            success: "#16794b",
            warning: "#a15c00",
            danger: "#b42318",
            info: "#1769aa"
        }
    },
    space: {
        1: "0.25rem",
        2: "0.5rem",
        3: "0.75rem",
        4: "1rem",
        6: "1.5rem",
        8: "2rem"
    },
    radius: {
        small: "0.375rem",
        medium: "0.625rem",
        large: "1rem"
    },
    typography: {
        family: "Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif",
        size: {
            small: "0.875rem",
            body: "1rem",
            title: "1.5rem",
            display: "2rem"
        }
    }
};
//# sourceMappingURL=index.js.map